// APP REDUCERS
export const APP_SET_LOGIN_STATE = "APP_SET_LOGIN_STATE";
export const APP_SET_WINDOW_SIZE = "APP_SET_WINDOW_SIZE";